module.exports = __webpack_public_path__ + "static/MoneyBillImage-57e6232cc63d75214f3355ebeedea8bd.png";